import { createFileRoute } from '@tanstack/react-router';
import { PacksPage } from '@/page/admin/PacksPage';

export const Route = createFileRoute('/_app/admin/packs/')({ component: PacksPage });
